import { Component, OnInit } from '@angular/core';
import { EditorService } from '../../../../bookeditoption/editor.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-url',
  templateUrl: './url.component.html',
  styleUrls: ['./url.component.css']
})
export class UrlComponent implements OnInit {
  mediaUrlSrc = '';
  mediaUrlDesc = '';
  isLinkChecked = false;
  inputDisabled = true;
  urlDefaultColor = "#0585fe";
  uHeaderVal = 'http';
  isValidUrl = false;
  urlColorcode: any = ['#e5d05c', '#b6ee6a', '#6db1f0', '#f77bc1', '#ca84e7', '#0585fe'];
  urlHeader = ['http', 'https'];

  constructor(private editorService: EditorService, private http: HttpClient) { }

  ngOnInit() {
    let cardData = this.editorService.textInlineData;
    if (cardData && cardData.type == "URLLOAD") {
      this.initializeData(cardData);
    }

  }
  initializeData(data) {
    if (data.url) {
      this.mediaUrlSrc = data.url;
      let domainH = this.mediaUrlSrc.includes('http');
      let domainHs = this.mediaUrlSrc.includes('https');
      if (domainH && this.mediaUrlSrc != "" && !domainHs) {
        this.mediaUrlSrc = this.mediaUrlSrc.replace('http://', '');
        this.uHeaderVal = "http";
      }
      if (this.mediaUrlSrc != "" && domainHs) {
        this.mediaUrlSrc = this.mediaUrlSrc.replace('https://', '');
        this.uHeaderVal = "https";
      }

    }
    if (data.color) {
      this.urlDefaultColor = data.color;
    }
    if (data.isLink == "true") {
      this.isLinkChecked = true;
      this.inputDisabled = false;
    } else {
      this.isLinkChecked = false;
      this.inputDisabled = true;
      this.mediaUrlDesc = '';
    }
    if (data.linkText) {
      this.mediaUrlDesc = data.linkText;
    }
  }
  checkURLformat(testUrl) {
    var res = testUrl.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    if (res == null)
      return false;
    else
      return true;
  }

  updateMediaUrlSrc() {

    this.http.get<any>(this.mediaUrlSrc, { observe: 'response' })
      .subscribe(resp => {
        console.log(resp.headers);
      });
    let urlIsValid = this.checkURLformat(this.mediaUrlSrc);
    if (!urlIsValid) {
      this.isValidUrl = true;
      return;
    } else {
      this.isValidUrl = false;
    }
    let upDateUrl;
    let domainH = this.mediaUrlSrc.includes('http');
    let domainHs = this.mediaUrlSrc.includes('https');

    if (domainH && this.mediaUrlSrc != "" && !domainHs) {
      let newUrl = this.mediaUrlSrc.replace('http', '');
      this.mediaUrlSrc = this.mediaUrlSrc.replace('http://', '');
      upDateUrl = "http" + newUrl;
      this.uHeaderVal = "http";
    }

    else if (this.mediaUrlSrc != "" && domainHs) {
      let newUrl = this.mediaUrlSrc.replace('https', '');
      this.mediaUrlSrc = this.mediaUrlSrc.replace('https://', '');
      upDateUrl = "https" + newUrl;
      this.uHeaderVal = "https";
    }
    else {
      upDateUrl = this.uHeaderVal + "://" + this.mediaUrlSrc;
    }
    let layer = this.editorService.getIframeReference();
    let urlObj: any = {};


    urlObj.url = upDateUrl;
    urlObj.isLink = this.isLinkChecked.toString();
    urlObj.linkText = this.mediaUrlDesc;
    urlObj.color = this.urlDefaultColor;
    if (this.isLinkChecked && this.mediaUrlDesc == "") {
      urlObj.linkText = "Link to " + upDateUrl;
    }
    layer.updateSrcForUrlLoad(urlObj);

  }

  checkUrlLink() {
    this.isLinkChecked = !this.isLinkChecked;
    if (this.isLinkChecked) {
      this.inputDisabled = false;
    } else {
      this.inputDisabled = true;
      this.mediaUrlDesc = '';
    }
    if (this.mediaUrlSrc != "")
      this.updateMediaUrlSrc();
  }
  changeUrlButtonColor(clr) {
    this.urlDefaultColor = clr;
    this.updateMediaUrlSrc();
  }
  changeUrlDomain(domain) {
    this.updateMediaUrlSrc();
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/url/url.component.ts